<template>
<section class="bio px-4 py-12">
    <div class="max-w-4xl mx-auto">
        <div class="grid" :class="{'no-photo': !image}">
            <div class="crumbs flex items-center">
                <Link href="/people" class="underline transition-colors text-white hover:text-primary-500 focus:text-primary-500">People</Link> <i class="fa-solid mx-2 inline-block fa-chevrons-right text-gray-300 text-xs" aria-hidden="true"></i> <span class="text-gray-300" v-html="name"></span>
            </div>
            <div class="headshot" v-if="image">
                <img :src="image.src" :alt="image.alt">
            </div>
            <div class="bio prose text-white" v-html="bio"></div>
        </div>
    </div>
</section>
</template>

<script>

export default {

    props: ['data'],
    
    setup(props) {
        return {
            ...props.data
        }
    }

}
</script>